import { NgClass } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AutoFocus } from 'primeng/autofocus';
import { Divider } from 'primeng/divider';
import { FloatLabel } from 'primeng/floatlabel';
import { Ripple } from 'primeng/ripple';
import { Select } from 'primeng/select';
import { AuthService } from '../../../core/services/auth.service';
import { I18nService } from '../../../core/services/i18n.service';
import { RuntimeConfigService } from '../../../core/services/runtime-config.service';
import { SpsMenuItem } from '../../interfaces/sps-menu-item';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'sps-profile-overlay-menu',
  imports: [
    FloatLabel,
    Select,
    FormsModule,
    NgClass,
    Divider,
    Ripple,
    RouterLink,
    AutoFocus
  ],
  templateUrl: './profile-overlay-menu.component.html'
})
export class ProfileOverlayMenuComponent implements OnInit, AfterViewInit {

  /**
   * Menu-Items for autofocus and keyboard-Control
   */
  @ViewChildren('menuLink') linkElements!: QueryList<ElementRef<HTMLAnchorElement>>;
  private links: ElementRef<HTMLAnchorElement>[] = [];

  /** event emitter for menu item click */
  @Output() itemClicked = new EventEmitter<SpsMenuItem>();

  /** menu items for the topbar settings menu */
  menuItems: SpsMenuItem[] = [];


  constructor(public authService: AuthService,
              public i18n: I18nService,
              public layoutService: LayoutService,
              private runtimeConfig: RuntimeConfigService) {
  }

  ngOnInit() {

    /** init menu items for the topbar settings menu */
    this.menuItems = [
      {
        i18nLabelKey: 'CUSTOMERDATA',
        // icon: 'pi pi-user',
        id: 'CUSTOMERDATA',
        autoFocus: true
      },
      /** currently disabled
      {
        i18nLabelKey: 'USERSANDTEAM',
        // icon: 'pi pi-users',
        id: 'USERSANDTEAM'
      },
      {
        i18nLabelKey: 'CONTRACTS',
        // icon: 'pi pi-file-check',
        id: 'CONTRACTS'
      },
      {
        i18nLabelKey: 'PRICING',
        // icon: 'pi pi-file-check',
        id: 'PRICING'
      },
      {
        i18nLabelKey: 'BILLING',
        // icon: 'pi pi-sign-out',
        id: 'BILLING'
      },
        */
      {
        i18nLabelKey: 'USERADMINISTRATION',
        icon: 'pi pi-external-link',
        id: 'USERADMINISTRATION',
        url: this.runtimeConfig.zbvUserAdministrationUrl,
        target: '_blank',
      },
      {
        i18nLabelKey: 'PROFILEDATA',
        icon: 'pi pi-external-link',
        id: 'PROFILEDATA',
        url: this.runtimeConfig.zbvProfileDataUrl,
        target: '_blank',
      },
      {
        i18nLabelKey: 'CHANGEPASSWORD',
        icon: 'pi pi-external-link',
        id: 'CHANGEPASSWORD',
        url: this.runtimeConfig.zbvChangePasswordUrl,
        target: '_blank',
      },
    ];
    this.menuItems.push(
      {
        i18nLabelKey: 'LOGOUT',
        icon: 'pi pi-sign-out',
        command: () => {
          this.authService.logoutZBV();
        }
      }
    );
  }

  ngAfterViewInit() {
    this.links = this.linkElements.toArray();
    /**
     * Workaround
     * focus on first link
     * (force focus ring)
     */
    const first = this.linkElements.first;
    if (first) {
      first.nativeElement.focus({preventScroll: true});
      first.nativeElement.classList.add('force-focus-ring');
      const removeClass = () => {
        first.nativeElement.classList.remove('force-focus-ring');
        first.nativeElement.removeEventListener('blur', removeClass);
      };
      first.nativeElement.addEventListener('blur', removeClass);
    }
  }

  /**
   * callback function to change the current language
   */
  changeLanguage() {
    this.i18n.initPrimengTranslation(this.i18n.activeLanguage.value);
    this.i18n.initLanguageData(this.i18n.activeLanguage.value);
    // TODO check if necessary
    this.layoutService.refreshContent();
  }

  /**
   * callback function for click on menu item (no command menu item)
   */
  itemClick(event: Event, item: SpsMenuItem) {
    event.preventDefault();
    this.itemClicked.emit(item);
  }

  /**
   * callback function for click on command menu item
   */
  commandItemClick(event: Event, item: SpsMenuItem) {
    if (item.disabled) {
      event.preventDefault();
      return true;
    }
    /** execute command callback function */
    if (item.command) {
      item.command({originalEvent: event, item: item});
    }
  }

  /**
   * arrow-kay control for menu
   * @param event
   * @param index
   */
  onKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'ArrowDown') {
      let nextLinkIndex: number = index + 1;
      if (nextLinkIndex === this.links.length) {
        nextLinkIndex = 0;
      }
      this.links[nextLinkIndex].nativeElement.focus();
    }
    if (event.key === 'ArrowUp') {
      let previousLinkIndex: number = index - 1;
      if (previousLinkIndex === -1) {
        previousLinkIndex = this.links.length - 1;
      }
      this.links[previousLinkIndex].nativeElement.focus();
    }
  }
}
